import { Routes } from '@angular/router';

export const nlScheduleVirtualAppointmentRoutes: Routes = [
  {
    path: 'health-coach-appointment',
    loadComponent: () =>
      import('./pages/schedule-health-coach-appointment/schedule-health-coach-appointment.page').then(
        (m) => m.ScheduleHealthCoachAppointmentPage,
      ),
  },
  {
    path: 'health-coach-appointment/review',
    loadComponent: () =>
      import('./pages/nl-schedule-virtual-review/nl-schedule-virtual-review.page').then(
        (m) => m.NlScheduleVirtualReviewPage,
      ),
  },
];
